<template>
  <v-card>
    <v-card-text>

      <v-row>
        <v-col cols="2.5">
          <v-text-field
            class=" input-text-size"
            v-model="editItem.countyName"
            label="County Name"
            :rules="countyNameValidation"
            required
          ></v-text-field>
        </v-col>

        <v-col cols="2.5">
        <v-text-field
          class="input-text-size"
          v-model="editItem.countyNumber"
          label="County Number"
          required
          ></v-text-field>
        </v-col>

          <v-col cols="2.5">
          <v-text-field
            class=" input-text-size"
            v-model="editItem.treasurerPhone"
            label="Treasurer Phone"
            required
          ></v-text-field>
          </v-col>

          <v-col cols="2.5" >
          <v-text-field
            class=" input-text-size"
            v-model="editItem.treasurerFax"
            label="Treasurer Fax"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="2.5" >
          <v-text-field
            class=" input-text-size"
            v-model="editItem.treasurerEmail"
            label="Treasurer Email"
            required
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
          <v-col cols="2.5">
          <v-text-field
            class=" input-text-size"
            v-model="editItem.treasurerWebsite"
            label="Treasurer Website"
            required
          ></v-text-field>
        </v-col>

        <v-col cols="2.5">
          <v-text-field
            class=" input-text-size"
            v-model="editItem.treasurerName"
            label="Treasurer Name"
            required
          ></v-text-field>
        </v-col>

        <v-col cols="2.5">
          <v-text-field
            class=" input-text-size"
            v-model="editItem.countyClerkName"
            label="County Clerk's Name"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="2.5">
          <v-text-field
            class=" input-text-size"
            v-model="editItem.countyAssessorName"
            label="County Assessor's Name"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="2.5">
          <v-text-field
            class=" input-text-size"
            v-model="editItem.countyAssessorPhone"
            label="County Assessor Phone"
            required
          ></v-text-field>
          </v-col>

        <v-col cols="2.5">
          <v-text-field
            class=" input-text-size"
            v-model="editItem.exciseChairman"
            label="Excise - Chairman"
            required
          ></v-text-field>
        </v-col>
        </v-row>

        <v-row>
        <v-col
          cols="2.5">
          <v-text-field
            class=" input-text-size"
            v-model="editItem.exciseViceChairman"
            label="Excise - Vice-Chairman"
            required
          ></v-text-field>
        </v-col>

        <v-col cols="2.5">
          <v-text-field
            class=" input-text-size"
            v-model="editItem.exciseMember"
            label="Excise - Member"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="2.5">
          <v-text-field
            class=" input-text-size"
            v-model="editItem.commissionerChairman"
            label="Commissioner - Chairman"
            required
          ></v-text-field>
        </v-col>

        <v-col cols="2.5">
          <v-text-field
            class=" input-text-size"
            v-model="editItem.commissionerViceChairman"
            label="Commissioner - Vice-Chairman"
            required
          ></v-text-field>
        </v-col>

        <v-col cols="2.5">
          <v-text-field
            class=" input-text-size"
            v-model="editItem.commissionerMember"
            label="Commissioner - Member"
            required
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2.5">
          <!-- <v-text-field
            class=" input-text-size"
            v-model="editItem.businessDate"
            label="Business Date(dd/mm/yyyy)"
            type="date"
            required
          ></v-text-field> -->
          <ClarionDateControl class="input-text-size" label="Business Date(dd/mm/yyyy)"
            v-model="editItem.businessDate" :isToggle=false />
        </v-col>
        <v-col cols="2.5">
          <v-text-field
            class=" input-text-size"
            v-model="editItem.globalTitle"
            label="Global title"
          ></v-text-field>
        </v-col>

        <v-col cols="2.5">
          <v-text-field
            class=" input-text-size"
            v-model="editItem.hoursOfOperation"
            label="Hours of operation"
          ></v-text-field>
        </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
          <v-text-field
            class=" input-text-size"
            v-model="editItem.FederalId"
            label="Federal ID"
          ></v-text-field>
        </v-col>

        </v-row>

  <v-row  class="my-n2">
    <v-col cols="12">
      <h3 class="text-decoration-underline input-text-size">Treasurer Address:</h3>
    </v-col>
    <v-col cols="2.5">
      <v-textarea
        class="input-text-size"
        v-model="editItem.addressAdd1"
        label="Add1"
        rows="1"

      ></v-textarea>
    </v-col>

    <v-col cols="2.5">
      <v-textarea
        class="input-text-size"
        v-model="editItem.addressAdd2"
        label="Add2"
        rows="1"

      ></v-textarea>
    </v-col>

    <v-col cols="2.5">
      <v-textarea
        class="input-text-size"
        v-model="editItem.addressAdd3"
        label="Add3"
        rows="1"

      ></v-textarea>
    </v-col>

    <v-col cols="2.5">
      <v-text-field
        class="input-text-size mt-4"
        v-model="editItem.addressCity"
        label="City"
        required
        dense
      ></v-text-field>
    </v-col>

    <v-col cols="2.5">
      <v-text-field
        class="input-text-size mt-4"
        v-model="editItem.addressState"
        label="State"
        required
        dense
      ></v-text-field>
    </v-col>

    <v-col cols="2.5">
      <v-text-field
        class="input-text-size mt-4"
        v-model="editItem.addressZip"
        label="Zip"
        required
        dense
      ></v-text-field>
    </v-col>
    <v-col cols="2.5">
          <v-text-field
            class=" input-text-size"
            v-model="editItem.sherrifPhone"
            label="Sheriff Phone"
            required
          ></v-text-field>
          </v-col>
  </v-row>
  <v-row class="my-n2">
    <v-col cols="12">
      <h3 class="text-decoration-underline input-text-size">Sheriff Address:</h3>
    </v-col>
    <v-col cols="2.5">
      <v-textarea
        class="input-text-size"
        v-model="editItem.sherrifAddressAdd1"
        label="Add1"
        rows="1"

      ></v-textarea>
    </v-col>

    <v-col cols="2.5">
      <v-textarea
        class="input-text-size"
        v-model="editItem.sherrifAddressAdd2"
        label="Add2"
        rows="1"

      ></v-textarea>
    </v-col>

    <v-col cols="2.5">
      <v-textarea
        class="input-text-size"
        v-model="editItem.sherrifAddressAdd3"
        label="Add3"
        rows="1"

      ></v-textarea>
    </v-col>

    <v-col cols="2.5">
      <v-text-field
        class="input-text-size mt-4"
        v-model="editItem.sherrifAddressCity"
        label="City"
        required
        dense
      ></v-text-field>
    </v-col>

    <v-col cols="2.5">
      <v-text-field
        class="input-text-size mt-4"
        v-model="editItem.sherrifAddressState"
        label="State"
        required
        dense
      ></v-text-field>
    </v-col>

    <v-col cols="2.5">
      <v-text-field
        class="input-text-size mt-4"
        v-model="editItem.sherrifAddressZip"
        label="Zip"
        required
        dense
      ></v-text-field>
    </v-col>
  </v-row>
  <h3 class="text-decoration-underline input-text-size">Payment Configuration:</h3>
     <v-row>
        <v-col cols="3">
          <v-text-field
            class=" input-text-size"
            v-model.number="editItem.convenienceFee"
            type="number"
            label="Convenience Fee(%)"
            required
          ></v-text-field>
        </v-col>

        <v-col cols="3">
          <v-text-field
            class=" input-text-size"
            v-model.number="editItem.penalty"
            type="number"
            label="Penalty"
            required
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="3">
        <h3 class="text-decoration-underline input-text-size">Forte Prod/Sandbox Setting:</h3>
        </v-col>

        <v-col cols="3">
        <h3 class="text-decoration-underline input-text-size">TM Prod/Sandbox Setting:</h3>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="3">
          <v-select
            class=" input-text-size"
            v-model="editItem.forteApiURL"
            :items="forteApiModesList"
            label="Forte Mode"
            item-value="apiURL"
            item-text="apiMode"
            dense
            outlined
          ></v-select>
          </v-col>

          <v-col cols="3">
          <v-select
            class=" input-text-size"
            v-model="editItem.payrixApiUrl"
            :items="payrixApiModesList"
            label="TM Mode"
            item-value="apiURL"
            item-text="apiMode"
            dense
            outlined
          ></v-select>
          </v-col>
      </v-row>

      <v-row>
        <v-col cols="2.5">
          <v-checkbox
            class="tmc-global-tax-unit-setting input-text-size "
            v-model="editItem.useNewTaxUnitSetup"
            label="Use New Tax Unit setup"/>
        </v-col>
        <v-col cols="2.5">
          <v-checkbox
            class="tmc-global-tax-unit-setting input-text-size"
            v-model="editItem.conEverythingToCaps"
            label="All Caps override"/>
        </v-col>
        <v-col cols="2.5">
          <v-checkbox
            class="tmc-global-tax-unit-setting input-text-size"
            v-model="editItem.disablePasswordAutoFill"
            label="Disable Password Auto-Fill"/>
        </v-col>
        <v-col cols="2.5">
          <v-checkbox
            class="tmc-global-tax-unit-setting input-text-size"
            v-model="editItem.useAtlasSearch"
            label="Use Atlas Search (Tax Inquiry)"/>
        </v-col>
        <v-col cols="2.5">
          <v-checkbox
            class="tmc-global-tax-unit-setting input-text-size"
            v-model="editItem.useWkstNoFromUser"
            label="Use wkst from User-list"/>
        </v-col>
        <v-col cols="2.5">
          <v-checkbox
            class="tmc-global-tax-unit-setting input-text-size"
            v-model="editItem.scanByWkst"
            label="Scan to Workstation Folder"/>
        </v-col>
        <v-col cols="2.5">
          <v-checkbox
            class="tmc-global-enable-tm-support-option input-text-size"
            v-model="editItem.enableTmSupportOption"
            label="Enable TM Support Option"/>
        </v-col>
      </v-row>
      <h3 class="input-text-size">Tax Business Date for entry applies to :
      </h3>
      <v-row>
        <v-col cols="3">
          <v-checkbox
            class="tmc-global-tax-unit-setting input-text-size "
            v-model="editItem.miscellaneous"
            label="Miscellaneous"/>
        </v-col>
        <v-col cols="3">
          <v-checkbox
            class="tmc-global-tax-unit-setting input-text-size"
            v-model="editItem.mtgTax"
            label="Mtg Tax"/>
        </v-col>
        <v-col cols="3">
          <v-checkbox
            class="tmc-global-tax-unit-setting input-text-size"
            v-model="editItem.od"
            label="Official Depository"/>
        </v-col>
      </v-row>
      <h3 class="input-text-size">Fee Waiver applies to:
      </h3>
      <v-row>
        <v-col cols="3">
          <v-checkbox
            class="tmc-global-fee-waiver input-text-size "
            v-model="editItem.feeWaiverMiscellaneous"
            label="Miscellaneous"/>
        </v-col>
        <v-col cols="3">
          <v-checkbox
            class="tmc-global-fee-waiver input-text-size"
            v-model="editItem.feeWaiverMtgTax"
            label="Mtg Tax"
            disabled/>
        </v-col>
        <v-col cols="3">
          <v-checkbox
            class="tmc-global-fee-waiver input-text-size"
            v-model="editItem.feeWaiverOd"
            label="Official Depository"
            disabled/>
        </v-col>
        <v-col cols="3">
          <v-checkbox
            class="tmc-global-fee-waiver input-text-size"
            v-model="editItem.feeWaiverTax"
            label="Tax"
            disabled/>
        </v-col>
      </v-row>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          depressed
          color="primary"
          @click="update"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  forteApiModes, payrixApiModes,
} from '../../util/shared/tmc-global';
import { pickGlobalSettingFormFields } from '../../util/shared/system-config-scopes';
import { cloneItem } from '../../util/shared/vue-global';
import ClarionDateControl from '../common/ClarionDateControl.vue';

export default {
  data: () => ({
    forteApiModesList: forteApiModes,
    payrixApiModesList: payrixApiModes,
    originalGlobalSetting: null,
  }),
  components: {
    ClarionDateControl,
  },
  computed: {
    editItem() {
      return this.$store.state.SystemConfig.globalSettingItem || {};
    },
    countyNameValidation() {
      return [
        (value) => !!value || 'Required',
        (value) => {
          const lowerValue = (value || '').toLowerCase();
          return lowerValue.indexOf('county') === -1 || 'Using "county" in the county name is redundant';
        },
      ];
    },
  },
  async created() {
    await this.$store.dispatch(
      'SystemConfig/loadConfig',
      { requiredScope: 'global' },
    );
    this.originalGlobalSetting = cloneItem(this.editItem);
  },
  methods: {
    /**
     * Full payload for save: store snapshot (other screens e.g. UsersList own
     * logoutTimePeriod / passExpPeriod) merged with this form’s fields.
     */
    mergeGlobalConfigForSave() {
      return {
        ...cloneItem(this.editItem),
        ...this.buildGlobalConfigItem(),
      };
    },
    buildGlobalConfigItem() {
      return pickGlobalSettingFormFields(this.editItem);
    },
    async update() {
      if (window.confirm('Are you sure want to update this configuration?')) {
        const payload = {
          calledScope: 'global',
          item: this.mergeGlobalConfigForSave(),
          previousItem: this.originalGlobalSetting,
          isLogAudit: true,
        };
        const ok = await this.$store.dispatch('SystemConfig/updateConfig', payload);
        if (ok) {
          this.originalGlobalSetting = cloneItem(this.editItem);
        }
      }
    },
  },
};
</script>
